import React, { useState, useEffect } from "react";

import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupText,
  Toast,
} from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import xls from "../../../assets/temp3.xls";
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { requestApi } from "../../../request-api";
import axios from "axios";
import { API_URL } from "../../../config";
import { userStore } from "../../../stores";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Triangle } from "react-loader-spinner";
import FileSaver from "file-saver";

function CreateCompany() {
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  const [message, setMessage] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [companyName, setCompanyName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [gstNum, setGstNum] = useState("");
  const [offcAddress, setOffcAddress] = useState("");
  const [pointOfCN, setPointOfCN] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [imageData, setImageData] = useState([]);
  const [xlsxError, setXlsxError] = useState("");
  const [csvInput, setCsvInput] = useState("b");
  let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  let [filename, setFilename] = useState("Choose File");
  let [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const successToast = (message) =>
    toast.success(message, {
      position: "bottom-right",
    });

  const errorToast = (error) =>
    toast.error(error, {
      position: "bottom-right",
    });

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

  const onFileChange = (event) => {
    event.preventDefault();
    setImageData(event.target.files);
    console.log("event.target.files[0]", event.target.files.length);
    file_select(event);
    if (event.target.files[0] == null) {
      setFilename("Choose File");
    } else {
      let i, filepath = "";
      for (i = 0; i < event.target.files.length; i++) {
        console.log("event.target.file[i].name", event.target.files[i].name);
        if (filepath == "") {
          filepath = filepath + event.target.files[i].name;
        } else {
          filepath = filepath + "," + event.target.files[i].name;
        }

      }

      setFilename(filepath);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    console.log("imageData------", imageData);
    let i;
    setLoading(true);
    try {
      let arrayStatus = [];
      for (i = 0; i < imageData.length; i++) {
        const formData = new FormData();
        formData.append("company_id", companyId);
        formData.append("company_name", companyName);
        formData.append("location", offcAddress,);
        let data = imageData[i];
        formData.append("file", data);
        formData.append("filename", data.name);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: userStore.token || "",
          },
        };

        const CreateTemplate = await axios.post(
          `${API_URL}/auditor/template/createTemplate`,
          formData,
          config,
          {
            body: JSON.stringify({
              company_name: companyName,
              company_id: companyId,
              formData,
            }),
          }
        )

        console.log("CreateTemplate status", CreateTemplate.data.statusCode)

        arrayStatus.push(CreateTemplate.status)

        if (CreateTemplate.data.statusCode == 403) {
          setLoading(false)
          errorToast(CreateTemplate.data.message)
          return
        }
        if (i == imageData.length - 1 && CreateTemplate.data.statusCode == 200) {
          console.log("in company")
          requestApi("/auditor/company/createCompany", {
            method: "post",
            body: JSON.stringify({
              company_name: companyName,
              company_id: companyId,
              gst_number: gstNum,
              date_of_mou: startDate,
              office_address: offcAddress,
              point_contact_name: pointOfCN,
              phone_number: phoneNum,
              template: CreateTemplate.data.data.template_id
            }),
          }).then((data) => {
            console.log("data", data);
            if (data.statusCode === 200) {
              setLoading(false)
              successToast("Successfully created company");
              navigate(`${directUrl}auditor/clients`);
            }
            if (data.statusCode === 203) {
              setLoading(false)
              errorToast(data.message);
            }else{
              errorToast(data.message);
            }

            setLoading(false)
          })
            .catch((error) => {
              setLoading(false)
              errorToast(error.message)
              console.log(error);
            });
        }

      }
    } catch (error) {
      setLoading(false);
      errorToast("Kindly Add proper format of Template");
      console.log(error);
    }
  };

  const formValidation = () => {
    const errors = {};
    const gstrgx =
      /^([0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})+$/;
    const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (companyName == "") {
      errors.companyname = "Company Name is required";
    }
    if (companyId == "") {
      errors.branchid = "Company ID is required";
    }
    if (gstNum == "") {
      errors.gstnumber = "GST Number is required";
    } else if (!gstrgx.test(gstNum)) {
      errors.gstnumber = "Invalid Number";
    }
    if (offcAddress == "") {
      errors.officeadd = "Office Address is required";
    }
    if (pointOfCN == "") {
      errors.pointofcontactname = "Point Of Contact Name is required";
    }
    if (phoneNum == "") {
      errors.pocnumber = "Phone Number is required";
    } else if (!mobRegex.test(phoneNum)) {
      errors.pocnumber = "Invalid Number";
    }
    if (imageData.length == 0) {
      errors.file = "File is required";
    }

    return errors;
  };

  const validateBanner = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const validate = formValidation();
    setFormErrors(validate);
    console.log("validate", validate);
    if (Object.keys(validate).length == 0) {
      submitForm(e);
    }
  };

  const file_select = (e) => {
    if (e.target.files[0] == null) {
      setFilename("Choose File");
    } else {
      let i,
        filepath = "";
      for (i = 0; i < e.target.length; i++) {
        console.log("e.target.file[i].name", e.target.file[i].name);
        filepath = filepath + e.target.files[i].name;
      }

      setFilename(filepath);
    }
  };

  return (
    <section className="lyt-section">
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}

      <Container fluid className="typ-container">
        <div className="breadcrumb-row">
          <Breadcrumb className="bs-breadcrumb mt-0">
            <BreadcrumbItem>
              <NavLink to={`${directUrl}auditor/dashboard`}>Home</NavLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <NavLink to={`${directUrl}auditor/clients`}>Clients</NavLink>
            </BreadcrumbItem>
            <BreadcrumbItem active>Create company</BreadcrumbItem>
          </Breadcrumb>
          <button
            className="bs-btn typ-white"
            onClick={() => {
              FileSaver.saveAs(xls, "Sample-template.xls");
            }}
          >
            {" "}
            <span class="icon icon-plus"></span> Sample Template{" "}
          </button>
        </div>
        <div className="bs-card px-0">
          <div className="padding-area">
            <form className="bs-form" enctype="multipart/form-data">
              <Row>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Company Name<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="company_name"
                    className="cstm-input"
                    placeholder="Enter Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                  <small className="error-message">
                    {formErrors.companyname}
                  </small>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Company ID<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="companyId"
                    className="cstm-input"
                    placeholder="Enter Company ID"
                    value={companyId}
                    onChange={(e) => setCompanyId(e.target.value)}
                  />
                  <small className="error-message">{formErrors.branchid}</small>
                </Col>
                {console.log(imageData)}
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    GST Number<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    className="cstm-input"
                    placeholder="Enter GST Number"
                    value={gstNum}
                    onChange={(e) => setGstNum(e.target.value)}
                  />
                  <small className="error-message">
                    {formErrors.gstnumber}
                  </small>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Date of MOU<span style={{ color: "red" }}>*</span>
                  </Label>
                  <div className="calender-area">
                    <DatePicker
                      id='dataOfMou'
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      placeholderText="Enter Date of MOU"
                    />
                    <label for='dataOfMou' className="icon icon-calendar"></label>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleText" className="cstm-label">
                    Office Address<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="text"
                    className="cstm-input"
                    value={offcAddress}
                    onChange={(e) => setOffcAddress(e.target.value)}
                    rows="5"
                    placeholder="Enter Office Address"
                  />
                  <small className="error-message">
                    {formErrors.officeadd}
                  </small>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Point of Contact Name<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    value={pointOfCN}
                    onChange={(e) => setPointOfCN(e.target.value)}
                    className="cstm-input"
                    placeholder="Enter Point of Contact Name"
                  />
                  <small className="error-message">
                    {formErrors.pointofcontactname}
                  </small>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Phone Number<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    value={phoneNum}
                    onChange={(e) => setPhoneNum(e.target.value)}
                    className="cstm-input"
                    placeholder="Enter Phone Number"
                  />
                  <small className="error-message">
                    {formErrors.pocnumber}
                  </small>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleEmail" className="mr-sm-2 cstm-label">
                    Upload List of Compliance template
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <div className="position-relative mob-mb-on">
                    <Input
                      type="file"
                      name="file"
                      className="file-input"
                      placeholder="Upload file"
                      id="file-input"
                      onChange={onFileChange}
                      multiple
                    />
                    <InputGroup className="choose-file">
                      <Input
                        placeholder={filename}
                        id="filename"
                        className="mb-0"
                      />
                      <InputGroupText>Choose File</InputGroupText>
                    </InputGroup>
                    <small className="error-message">{formErrors.file}</small>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <button
                    className="bs-btn"
                    type="button"
                    onClick={(e) => validateBanner(e)}
                  >
                    SUBMIT
                  </button>
                </Col>
              </Row>
            </form>
          </div>
        </div>
        <ToastContainer />
      </Container>
    </section>
  );
}

export default CreateCompany;
